import { useState } from 'react'
import { ProgressiveGroupCardProps, ProgressiveGroupHeader, ProgressiveGroupVariantRowSheet } from './index'
import { ProgressiveGroupOffer } from './ProgressiveGroupOffer'

const GREEN = '#748351'

/** Card de grupo para o sheet lateral (400-500px) — layout vertical sem grid de 5 colunas. */
export function ProgressiveGroupSheetCard({
  groupTitle,
  subtitle,
  groupOff,
  groupQty,
  nextHint,
  progressPct,
  milestones,
  variants,
  hasSavings,
  savingsFmt,
  offerProducts,
  onAdd,
  groupDiscountPct,
  capNote
}: ProgressiveGroupCardProps) {
  // Incrementado ao alterar quantidade de qualquer variante — sinaliza a oferta para abrir
  const [offerSignal, setOfferSignal] = useState(0)

  const wrappedVariants = variants.map((v) => ({
    ...v,
    onSelect: (n: number) => {
      v.onSelect(n)
      if (offerProducts?.length) setOfferSignal((s) => s + 1)
    }
  }))

  return (
    <div
      style={{
        border: '1.5px solid #dfe4c9',
        borderRadius: 14,
        margin: '10px 0',
        overflow: 'visible',
        background: '#fcfdf7'
      }}>
      <ProgressiveGroupHeader
        groupTitle={groupTitle}
        subtitle={subtitle}
        groupOff={groupOff}
        groupQty={groupQty}
        nextHint={nextHint}
        progressPct={progressPct}
        milestones={milestones}
        capNote={capNote}
        showIdentification={false}
      />

      {/* Variantes — layout vertical compacto via componente compartilhado */}
      <div style={{ padding: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
        {wrappedVariants.map((v) => (
          <ProgressiveGroupVariantRowSheet key={v.id} v={v} groupQty={groupQty} overlay />
        ))}
      </div>

      {/* Oferta cruzada: outros produtos da mesma regra (colapsável) */}
      {!!offerProducts?.length && !!onAdd && (
        <ProgressiveGroupOffer
          products={offerProducts}
          mode="sheet"
          onAdd={onAdd}
          openSignal={offerSignal}
          groupDiscountPct={groupDiscountPct}
        />
      )}

      {/* Footer compacto */}
      {hasSavings && !!savingsFmt && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '10px 14px',
            borderTop: '1px solid #e9edd5',
            background: '#f4f6e9',
            borderRadius: '0 0 12px 12px'
          }}>
          <span style={{ fontSize: 12, color: '#8a8a8a' }}>
            economia: <strong style={{ color: GREEN }}>{savingsFmt}</strong>
          </span>
        </div>
      )}
    </div>
  )
}
